import { InterstitialOverlay } from "@/components/overlay/interstitial-overlay";
import { useAppStore } from "@/store";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { MDSModal } from "@/mds";
import { WizardContainer } from "@/components/onboarding/components/welcome-wizard/onboarding-steps.styles";
import { Steps } from "@/components/onboarding/components/welcome-wizard/onboarding-steps.config";
import styled from "@emotion/styled";

interface WelcomeOverlayProps {}

export const WelcomeOverlay = observer<WelcomeOverlayProps>(() => {
  const { store } = useAppStore();
  const onboarding = store.onboarding;
  const isOpen = onboarding.isActive;
  const substepId = onboarding.currentSubstepId;

  useTrackView(isOpen);

  const stepConfig = substepId ? Steps[substepId] : undefined;

  if (!isOpen || !stepConfig) return null;

  const stepContent = stepConfig.render({
    onComplete: (...completedSteps: string[]) => {
      void onboarding.completeCurrentStep(completedSteps);
    },
  });

  return (
    <InterstitialOverlay isOpen={isOpen}>
      <MDSModal isOpen={isOpen} handleClose={() => {}}>
        <ModalContent>
          <WizardContainer data-component="wizard-container">{stepContent}</WizardContainer>
        </ModalContent>
      </MDSModal>
    </InterstitialOverlay>
  );
});

const useTrackView = (isOpen: boolean) => {
  const { store } = useAppStore();

  useEffect(() => {
    if (!isOpen) return;
    store.metrics.trackWelcomeOverlayView();
  }, [isOpen, store.metrics]);
};

const ModalContent = styled.div`
  overflow: hidden;
  position: absolute;
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  transform: translate(-50%, -50%);
`;
